export const HarborIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="1.05 -1.95 359.41 361.66"
      width="58px"
      height="58px"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="264.79"
          x2="267.27"
          y1="952.39"
          y2="952.39"
          gradientTransform="matrix(30.43 0 0 -30.43 -7955.22 29285.75)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#60b932" />
          <stop offset=".28" stopColor="#60b932" />
          <stop offset="1" stopColor="#367c34" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="263.77"
          x2="266.26"
          y1="955.65"
          y2="955.65"
          gradientTransform="matrix(27.21 0 0 -27.21 -7073.85 26169.41)"
          xlinkHref="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-3"
          x1="263.28"
          x2="265.76"
          y1="953.74"
          y2="953.74"
          gradientTransform="matrix(25.75 0 0 -25.75 -6671.13 24812.23)"
          xlinkHref="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-4"
          x1="263.77"
          x2="266.25"
          y1="953.2"
          y2="953.2"
          gradientTransform="matrix(27.1 0 0 -27.1 -7040.9 26102.49)"
          xlinkHref="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-5"
          x1="262.73"
          x2="265.21"
          y1="954.34"
          y2="954.34"
          gradientTransform="matrix(24.4 0 0 -24.4 -6301.36 23521.97)"
          xlinkHref="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-6"
          x1="272.14"
          x2="274.62"
          y1="955.15"
          y2="955.15"
          gradientTransform="scale(66.09 -66.09) rotate(36.52 1588.153 68.148)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4596d8" />
          <stop offset=".2" stopColor="#4596d8" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1="270.65"
          x2="273.13"
          y1="952.38"
          y2="952.38"
          gradientTransform="scale(77.8 -77.8) rotate(-11.54 -4587.209 1803.323)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4194d7" />
          <stop offset=".2" stopColor="#4194d7" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-8"
          x1="270.97"
          x2="273.45"
          y1="953.75"
          y2="953.75"
          gradientTransform="scale(71.35 -71.35) rotate(10.23 5477.37 -1024.602)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4194d7" />
          <stop offset=".33" stopColor="#4496d8" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <clipPath id="clip-path">
          <path
            d="M174.4 302.52l-68.65-30.26-3.83 43.21 75.5 23.98-3.02-36.93z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            d="M119.19 135.38h38.55v32.89h-9.15v-14a10.13 10.13 0 1 0-20.26 0v14h-9.15zm-7.7 72l57.2 25.21-3.94-48.24h7.49v-16.08h-5.55v-32.89h5.55v-9.45l-30.86-30.19v-2.12a2.91 2.91 0 0 0-5.82 0v2.12l-30.86 30.19v9.45h5.56v32.89h-5.56v16.12h8.82z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <path
            d="M108.14 245.28l63.88 28.16-.96-11.73-61.96-27.3-.96 10.87z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            d="M106.46 264.21l67.23 29.63-.96-11.72-65.31-28.78-.96 10.87z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            d="M110.77 215.48l-.96 10.87 60.54 26.68-.95-11.72-58.63-25.83z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-6">
          <path
            d="M313.13 67.59a175.31 175.31 0 0 0-29.75-28.13c-1.57-1.17-3.18-2.3-4.79-3.42L256 59.5l-82.34 85.63 113.41-58.68 29.07-15c-1.01-1.31-1.98-2.62-3.01-3.86z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            d="M353.59 177.61c0-2-.14-4-.22-5.93l-32.21-2.31-147.47-10.58L318.36 209l30.41 10.55c.09-.36.19-.71.28-1.08a173.65 173.65 0 0 0 4.57-39.47v-1.37z"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-8">
          <path
            d="M348.84 138.61a172.55 172.55 0 0 0-13.84-37.7l-30.94 9.94L175.92 152l142-4.83 32.5-1.11c-.5-2.48-.99-4.98-1.58-7.45z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="g12">
        <path
          id="path14"
          fill="#fff"
          d="M30.89 179a148.87 148.87 0 1 1 148.87 148.85A148.87 148.87 0 0 1 30.89 179"
        />
        <g id="g30" clipPath="url(#clip-path)">
          <g id="g32">
            <path
              id="path46"
              fill="url(#linear-gradient)"
              d="M174.4 302.52l-68.65-30.25-3.82 43.2 75.5 24-3-36.93"
            />
          </g>
        </g>
        <g id="g48" clipPath="url(#clip-path-2)">
          <g id="g50">
            <path
              id="path64"
              fill="url(#linear-gradient-2)"
              d="M119.19 135.38h38.55v32.89h-9.15v-14a10.13 10.13 0 1 0-20.26 0v14h-9.15zm-7.7 72l57.2 25.21-3.94-48.24h7.49v-16.08h-5.55v-32.89h5.55v-9.45l-30.86-30.19v-2.12a2.91 2.91 0 0 0-5.82 0v2.12l-30.86 30.19v9.45h5.56v32.89h-5.56v16.12h8.82l-2 23"
            />
          </g>
        </g>
        <g id="g66" clipPath="url(#clip-path-3)">
          <g id="g68">
            <path
              id="path82"
              fill="url(#linear-gradient-3)"
              d="M108.13 245.28L172 273.44l-1-11.72-62-27.31-1 10.87"
            />
          </g>
        </g>
        <g id="g84" clipPath="url(#clip-path-4)">
          <g id="g86">
            <path
              id="path100"
              fill="url(#linear-gradient-4)"
              d="M106.46 264.21l67.23 29.63-1-11.72-65.31-28.78-1 10.87"
            />
          </g>
        </g>
        <g id="g102" clipPath="url(#clip-path-5)">
          <g id="g104">
            <path
              id="path118"
              fill="url(#linear-gradient-5)"
              d="M110.77 215.48l-1 10.88L170.35 253l-1-11.72-58.62-25.83"
            />
          </g>
        </g>
        <path
          id="path120"
          d="M304.07 110.85l30.93-9.94c-.11-.22-.21-.45-.32-.66a174.41 174.41 0 0 0-18.55-28.83l-29.07 15a142.71 142.71 0 0 1 16.73 23.87c.1.17.18.35.27.53"
          fill="#696566"
        />
        <path
          id="path122"
          d="M321.15 169.37l32.21 2.31a172.86 172.86 0 0 0-3-25.59l-32.5 1.11a141 141 0 0 1 3.25 22.17"
          fill="#696566"
        />
        <path
          id="path124"
          d="M182 320.81c-78.2 0-141.83-63.62-141.83-141.82S103.82 37.16 182 37.16a140.93 140.93 0 0 1 76.3 22.34L280.85 36A172.86 172.86 0 0 0 182 5.11C86.15 5.11 8.15 83.11 8.15 179s78 173.85 173.85 173.85c81.9 0 150.69-57 169-133.32L320.62 209c-13.8 63.84-70.69 111.83-138.6 111.83"
          fill="#696566"
        />
        <g id="g126" clipPath="url(#clip-path-6)">
          <g id="g128">
            <path
              id="path142"
              fill="url(#linear-gradient-6)"
              d="M313.13 67.59a175.31 175.31 0 0 0-29.75-28.13c-1.57-1.17-3.18-2.3-4.79-3.42L256 59.5l-82.34 85.63 113.41-58.68 29.07-15c-1-1.27-2-2.58-3-3.82"
            />
          </g>
        </g>
        <g id="g144" clipPath="url(#clip-path-7)">
          <g id="g146">
            <path
              id="path160"
              fill="url(#linear-gradient-7)"
              d="M353.59 177.61c0-2-.14-4-.22-5.93l-32.21-2.31-147.47-10.58L318.36 209l30.41 10.55c.09-.36.19-.71.28-1.08a173.65 173.65 0 0 0 4.57-39.47v-1.37"
            />
          </g>
        </g>
        <g id="g162" clipPath="url(#clip-path-8)">
          <g id="g164">
            <path
              id="path178"
              fill="url(#linear-gradient-8)"
              d="M348.84 138.61a172.55 172.55 0 0 0-13.84-37.7l-30.94 9.94L175.92 152l142-4.83 32.5-1.11c-.48-2.51-1-5-1.56-7.48"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
